import { Component, OnInit } from '@angular/core';
import { GeneralSettingsService } from '../../Services/general-settings.service';

@Component({
  selector: 'app-general-member-information',
  template: require('./general-member-information.component.html'),
  styles: [require('./general-member-information.component.css')]
})
export class GeneralMemberInformationComponent implements OnInit {

  constructor(private generalSettingsService:GeneralSettingsService) { }
  bankAccount:string=""
  ngOnInit() {
    this.generalSettingsService.getBankAccount().subscribe( (res:any)=>{
      if (res.status == 200){
        this.bankAccount = res.value.bankAccount;
      }
    })
  }


  isEmptyObject(obj: any) {
    var name;
    for (name in obj) {
        if (obj.hasOwnProperty(name)) {
            return false;
        }
    }
    return true;
}

}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./ClientApp/app/components/general-member-information/general-member-information.component.ts